import { createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  addAttachment: ["attachmentId", "data"], // Thêm attachment mới
  updateAttachmentProgress: ["attachmentId", "progress", "bytesTotal", "fileOperation"], // Cập nhật tiến trình
  completeAttachment: ["attachmentId"], // Đánh dấu hoàn thành
  removeAttachment: ["attachmentId"], // Xóa attachment khi hoàn thành
});

export const AttachmentTypes = Types;
export const AttachmentActions = Creators;

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
  attachments: {}, // Lưu trạng thái của các attachment theo `attachmentId`
};

/* ------------- Selectors ------------- */
export const AttachmentSelectors = {
  // Lấy tất cả các attachment
  getAllAttachments: state => state.attachmentRedux.attachments,

  // Lấy attachment theo ID
  getAttachmentById: (state, attachmentId) => state.attachmentRedux.attachments[attachmentId],
};

/* ------------- Reducers ------------- */
const addAttachment = (state = INITIAL_STATE, action) => ({
  ...state,
  attachments: {
    ...state.attachments,
    [action.attachmentId]: {
      ...action.data,
      progress: 0, // Mặc định tiến trình là 0%
      status: "active", // Trạng thái ban đầu là "active"
    },
  },
});

const updateAttachmentProgress = (state = INITIAL_STATE, action) => ({
  ...state,
  attachments: {
    ...state.attachments,
    [action.attachmentId]: {
      ...state.attachments[action.attachmentId],
      progress: action.progress, // Cập nhật tiến trình
      total: action.bytesTotal,
      fileOperation: action?.fileOperation,
    },
  },
});

const completeAttachment = (state = INITIAL_STATE, action) => ({
  ...state,
  attachments: {
    ...state.attachments,
    [action.attachmentId]: {
      ...state.attachments[action.attachmentId],
      status: "completed", // Đánh dấu trạng thái là "completed"
    },
  },
});

const removeAttachment = (state = INITIAL_STATE, action) => {
  const { [action.attachmentId]: _, ...remainingAttachments } = state.attachments;
  return {
    ...state,
    attachments: remainingAttachments, // Xóa attachment khỏi danh sách
  };
};

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.ADD_ATTACHMENT:
      return addAttachment(state, action);
    case Types.UPDATE_ATTACHMENT_PROGRESS:
      return updateAttachmentProgress(state, action);
    case Types.COMPLETE_ATTACHMENT:
      return completeAttachment(state, action);
    case Types.REMOVE_ATTACHMENT:
      return removeAttachment(state, action);
    default:
      return state;
  }
};
